export const validationUtilsService = {
    validateEmail,
    getEmailErrorMessage,
    getPostalCodeErrorMessage,
    validateField,
    getFieldErrorMessage
};

const DEFAULT_REQUIRED_MESSAGE = "Feld ist ein Pflichtfeld";
const DEFAULT_MAX_LENGTH_MESSAGE = "Maximale Länge ist ";
const DEFAULT_MIN_LENGTH_MESSAGE = "Minimale Länge ist ";
const DEFAULT_EMAIL_MESSAGE = "Bitte geben Sie eine korrekte E-Mail Adresse ein";
const DEFAULT_MUST_MATCH_MESSAGE = "Feld muss mit anderem Feld übereinstimmen";

// https://stackoverflow.com/a/46181
function validateEmail(email) {
    const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return re.test(String(email).toLowerCase());
}

function getEmailErrorMessage(email) {
    if(email.length === 0) {
        return 'Bitte geben Sie eine E-Mail ein'
    } else if (!validateEmail(email)) {
        return "Bitte geben Sie eine valide E-Mail Adresse ein"
    }
}

function getPostalCodeErrorMessage() {
    return 'Bitte geben Sie eine 5-Stellige Postleitzahl ein';
}


/**
 *
 * Validation object has to have following structure
 *
 * {
 *     submitted: true/false,
 *     yourField; {
 *          dirty: true/false
 *          required: true/false,
 *          maxLength: number,
 *          minLength: number
 *     }
 * }
 *
 * @param validation validation object
 * @param fieldName field name represented in validation object
 * @param value value of the field
 * @param mustMatchValue if you want to check if the field has a special value
 *
 */

function validateField(validation, fieldName, value, mustMatchValue) {
    if(!validation.submitted && !validation[fieldName].dirty) {
        return null;
    }
    const fieldValidators = validation[fieldName];
    if(!fieldValidators) {
        return null;
    }
    if(fieldValidators.required && value.length === 0) {
        return false;
    }
    if(fieldValidators.maxLength && value.length > fieldValidators.maxLength) {
        if(!fieldValidators.required && value.length > 0) {
            return false;
        }
    }
    if(fieldValidators.minLength && value.length < fieldValidators.minLength) {
        if(!fieldValidators.required && value.length > 0) {
            return false;
        }
    }
    if(fieldValidators.email && !validateEmail(value)) {
        return false;
    }
    if(mustMatchValue && (value !== mustMatchValue)) {
        return false;
    }
    return null;
}

/**
 *
 * Validation object has to have following structure
 *
 * {
 *     submitted: true/false,
 *     yourField; {
 *          required: true/false,
 *          requiredMessage: text
 *          maxLength: number,
 *          maxLengthMessage: text,
 *          minLengthMessage: text
 *     }
 * }
 *
 * @param validation validation object
 * @param fieldName field name represented in validation object
 * @param value value of the field
 *
 */

function getFieldErrorMessage(validation, fieldName, value, mustMatchValue) {
    const fieldValidators = validation[fieldName];
    if(!fieldValidators) {
        return "Feld ist fehlerhaft";
    }
    if(fieldValidators.required && value.length === 0) {
        return fieldValidators.requiredMessage ? fieldValidators.requiredMessage : DEFAULT_REQUIRED_MESSAGE;
    }
    if(fieldValidators.maxLength && value.length > fieldValidators.maxLength) {
        return fieldValidators.maxLengthMessage ? fieldValidators.maxLengthMessage : DEFAULT_MAX_LENGTH_MESSAGE+fieldValidators.maxLength;
    }
    if(fieldValidators.minLength && value.length < fieldValidators.minLength) {
        return fieldValidators.minLengthMessage ? fieldValidators.minLengthMessage : DEFAULT_MIN_LENGTH_MESSAGE+fieldValidators.minLength;
    }
    if(fieldValidators.email && !validateEmail(value)) {
        return fieldValidators.emailMessage ? fieldValidators.emailMessage : DEFAULT_EMAIL_MESSAGE;
    }
    if(mustMatchValue && (value !== mustMatchValue)) {
        return fieldValidators.mustMatchMessage ? fieldValidators.mustMatchMessage : DEFAULT_MUST_MATCH_MESSAGE;
    }
    return "Feld ist fehlerhaft";
}
